exports = module.exports = require("../../../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".QdWkQlUpP_HkZR4CRtp82 .gsISTvUeyATHEeN6v_2mT .h9CgGfXkwAMAz1nPKjmg5{display:block;position:absolute;left:0;top:0;box-sizing:border-box}.QdWkQlUpP_HkZR4CRtp82 .gsISTvUeyATHEeN6v_2mT .h9CgGfXkwAMAz1nPKjmg5._18xwPp05SG-l4NpV1goxv3.ezygYA_MqEsS1PiYOFNpj{border-right:0}", ""]);
// Exports
exports.locals = {
	"monaco-editor": "QdWkQlUpP_HkZR4CRtp82",
	"margin-view-overlays": "gsISTvUeyATHEeN6v_2mT",
	"current-line": "h9CgGfXkwAMAz1nPKjmg5",
	"current-line-margin": "_18xwPp05SG-l4NpV1goxv3",
	"current-line-margin-both": "ezygYA_MqEsS1PiYOFNpj"
};